import React from "react";
import pick from "lodash/pick";
import PropTypes from "prop-types";
import { Flex } from "grid-styled";
import { reduxForm } from "redux-form";
import Address from "./Address";
import { AddressFields } from "./forms";
import { Panel, PanelHeader, PanelBody } from "./Panel";
import Button from "./Button";

const AddressForm = reduxForm({
  form: "addressEdit"
})(({ handleSubmit, labelText, onCancel }) => {
  return (
    <form onSubmit={handleSubmit}>
      <AddressFields name={labelText} />
      <Flex justify="flex-end">
        <Button type="button" onClick={onCancel} style={{ marginRight: 4 }}>
          Cancel
        </Button>
        <Button type="submit" variant="primary">
          Save
        </Button>
      </Flex>
    </form>
  );
});

class AddressCard extends React.Component {
  static propTypes = {
    labelText: PropTypes.string,
    address: PropTypes.object,
    onSave: PropTypes.func.isRequired
  };

  static defaultProps = {
    labelText: "Street Address"
  };

  state = {
    editing: false
  };

  save = values => {
    return this.props.onSave(values).then(this.toggleEdit);
  };

  toggleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  renderAddress() {
    return <Address address={this.props.address} />;
  }

  renderForm() {
    const initialValues = this.props.address
      ? pick(
          this.props.address,
          "id",
          "streetAddress",
          "aptNumber",
          "city",
          "state",
          "zipCode",
          "country"
        )
      : {};
    return (
      <AddressForm
        initialValues={initialValues}
        labelText={this.props.labelText}
        onSubmit={this.save}
        onCancel={this.toggleEdit}
      />
    );
  }

  render() {
    const { address, onSave, labelText, cardTitle, ...otherProps } = this.props;
    const { editing } = this.state;
    return (
      <Panel {...otherProps}>
        <PanelHeader>
          <span>{cardTitle}</span>
          <Button
            onClick={this.toggleEdit}
            style={{ marginLeft: "auto" }}
            size="sm"
            disabled={editing}
          >
            {editing ? "Editing" : "Edit"}
          </Button>
        </PanelHeader>
        <PanelBody>
          {editing ? this.renderForm() : this.renderAddress()}
        </PanelBody>
      </Panel>
    );
  }
}

export default AddressCard;



// WEBPACK FOOTER //
// ./src/components/AddressCard.js